module.exports = __webpack_public_path__ + "static/media/didaima.705981cd.png";